<template>
  <Popup :mobile="isMobile" no-close-button>
    <div class="report-outer-container">
      <template v-if="!moveForConfirmation">
        <div class="report-container">
          <div class="report-header">
            <header>
              <div class="report-heading">Report</div>
            </header>
            <span class="cancel-reporting">
            <b-icon font-scale="2.4" icon="x" style="cursor:pointer;"
                    @click="closePopup"></b-icon>
          </span>
          </div>
          <div class="report-categories-outer-container">
            <div class="report-categories-inner-container">
              <div class="report-category-question">
                <span>Why are you reporting this post?</span>
              </div>
              <div class="report-categories-container">
                <b-button variant="light" v-for="(category, index) in categories"
                          @click="reasonSelected(index)">{{category}}</b-button>
                <div class="report-button-container">
                  <b-button variant="light" class="report-button" @click="report">Report</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="reported-status-container">
          <div class="header-container">
            <div class="thanks-msg-container">
              <div class="header-icon">
                <b-icon icon="check2-circle" font-scale="3"></b-icon>
              </div>
              <div class="header-heading">
                <span>Thanks for letting us know</span>
              </div>
              <div class="header-subheading">
                <span>Your feedback is important in helping us keep the EliteFit.AI community safe</span>
              </div>
            </div>
          </div>
          <div class="body-container">
            <template v-if="!userInfo.blockedByMe">
              <b-button class="destructive" variant="light"
                        @click="block">Block {{userInfo.userName}}</b-button>
              <b-button v-if="userInfo.followedByMe" class="destructive" variant="light"
                        @click="unfollow">Unfollow {{userInfo.userName}}</b-button>
            </template>
          </div>
          <div class="footer-container">
            <b-button variant="light" @click="closePopup">Close</b-button>
          </div>
        </div>
      </template>
    </div>
  </Popup>
</template>
<script>
import Popup from "@/module_social/components/Popup";
import {devicesMixin} from "@/utils/devices";
import {createNamespacedHelpers} from "vuex";
import postMixins from "@/module_social/mixins/postMixins";
const {
  mapActions: reportActions,
  mapState: reportState,
} = createNamespacedHelpers("social");


export default {
  mixins: [devicesMixin, postMixins],
  components: {
    Popup,
  },
  data() {
    return {
      selectedReason: null,
      moveForConfirmation: false,
    }
  },
  props: {
    mobile: {
      type: Boolean, default: false
    },
    post: {
      type: Object, default: () => ({
        creator: {
          fullName: "shahbaj"
        }
      }), deep: true
    }
  },
  computed: {
    ...reportState(['postReportCategories']),

    categories() {
      return this.postReportCategories || [];
    }
  },
  methods: {
    ...reportActions(['unFollowUser', 'reportPost', 'blockUser']),

    async block() {
      await this.blockUser(this.userInfo.userId);
      this.closePopup();
    },
    async unfollow() {
      await this.unFollowUser(this.userInfo.userId);
      this.closePopup();
    },
    async reasonSelected(index) {
      this.selectedReason = this.categories[index];
    },
    async report() {
      await this.reportPost({
        postId: this.post.id,
        reason: this.selectedReason,
        userId: this.userInfo.userId,
      }).then(_ => this.moveForConfirmation = true);
    },
    closePopup() {
      this.$emit('closePopup');
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/style/_social.scss";

.report-outer-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.report-container, .reported-status-container {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 2;
  max-width: $max-width-mobile-post-menu;
  min-width: $min-width-mobile-post-menu;
  vertical-align: baseline;
  border-radius: 0 $spacing-half-x $spacing-half-x 0;
  background-color: $white;

  .report-categories-outer-container {
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    overflow: hidden;
    position: relative;
    vertical-align: baseline;
    align-items: stretch;
  }
}

.report-header {
  border-bottom: 0.5px solid $post-separator;
  border-radius: $spacing-1x $spacing-1x 0 0;
  display: flex;
  align-items: center;

  header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    flex-shrink: 1;
    max-width: calc(100% - #{$dim-6x});
    padding: $spacing-1x $spacing-half-x $spacing-1x $spacing-2x;

    .report-heading {
      display: inline-flex;
      align-items: center;
      font-size: $font-size-4x;
      font-weight: 600;
      margin-right: $spacing-half-x;
      text-overflow: ellipsis;
      justify-content: center;
    }
  }
}

.report-categories-inner-container {
  margin-top: $spacing-half-3x;
  overflow-y: visible;
  align-content: stretch;
  align-items: stretch;
  align-self: auto;
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;

  .report-category-question {
    overflow-y: visible;
    align-content: stretch;
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    margin-top: $spacing-1x;
    padding:  0 $spacing-2x;
    align-self: auto;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;

    span {
      line-height: 20px;
      font-size: $font-size-3x;
      font-weight: 600;
      word-wrap: break-word;
      word-break: break-word;
      white-space: pre-line;
      max-width: 100%;
    }
  }

  .report-categories-container {
    margin-top: $spacing-2x;
    align-content: stretch;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-grow: 0;
    align-items: stretch;
    align-self: auto;
    justify-content: flex-start;
    position: relative;

    .btn {
      border-top: 1px solid $post-separator;
      border-radius: 0;
      font-weight: 500;
      cursor: pointer;
      font-size: $font-size-3x;
      min-height: $dim-6x;
      text-align: left;
    }

    .report-button-container {
      border-top: 1px solid $post-separator;
      padding: 8px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .report-button {
        border: 1px solid $post-separator;
        border-radius: 24px;
        font-weight: 500;
        cursor: pointer;
        font-size: $font-size-4x;
        min-height: $dim-6x;
        text-align: center;
        min-width: 80%;
        margin: 0 auto;
        background-color: $main-color;
        color: $white;
      }
    }
  }
}

.reported-status-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  position: relative;

  .destructive {
    color: $destructive-color;
  }

  .header-container {
    display: flex;
    flex-direction: column;
    align-content: stretch;
    align-items: stretch;
    position: relative;
    padding: 0 $spacing-2x;
    margin-top: $spacing-2x;

    .thanks-msg-container {
      .header-icon {
        color: $main-color;
        justify-content: center;
        display: flex;
      }
      .header-heading {
        display: flex;
        flex-direction: column;
        margin-top: $spacing-3x;
        align-content: stretch;

        span {
          line-height: $font-size-5x;
          font-size: $font-size-4x;
          font-weight: 600;
          text-align: center;
          word-wrap: break-word;
          word-break: break-word;
          white-space: pre-line;
          max-width: 100%;
        }
      }
      .header-subheading {
        display: flex;
        flex-direction: column;
        align-content: stretch;
        align-items: stretch;
        margin-top: $spacing-1x;

        span {
          line-height: $font-size-4x;
          font-size: $font-size-3x;
          font-weight: 400;
          text-align: center;
          word-wrap: break-word;
          word-break: break-word;
          white-space: pre-line;
          max-width: 100%;
          color: rgb(115, 115, 115);
        }
      }
    }
  }
  .body-container {
    margin-top: $dim-5x;
    display: flex;
    flex-direction: column;

    .btn {
      border-top: 1px solid $post-separator;
      border-radius: 0;
      font-weight: 600;
      cursor: pointer;
      font-size: $font-size-3x;
      min-height: $dim-6x;
      text-align: left;
    }
  }
  .footer-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: stretch;
    margin: $spacing-2x 0;
    padding: 0 $spacing-2x;

    .btn {
      background-color: $main-color;
      color: $white;
      font-weight: 600;
      cursor: pointer;
      font-size: $font-size-4x;
      min-height: $dim-6x;
      border-radius: 30px;
      width: 80%;
    }
  }
}
</style>